import { render } from "./ObligationsAssistant.vue?vue&type=template&id=66e339e6"
import script from "./ObligationsAssistant.vue?vue&type=script&setup=true&lang=js"
export * from "./ObligationsAssistant.vue?vue&type=script&setup=true&lang=js"

import "./ObligationsAssistant.vue?vue&type=style&index=0&id=66e339e6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/tools/ObligationsAssistant.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66e339e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66e339e6', __exports__)) {
    api.reload('66e339e6', __exports__)
  }
  
  module.hot.accept("./ObligationsAssistant.vue?vue&type=template&id=66e339e6", () => {
    api.rerender('66e339e6', render)
  })

}


export default __exports__